import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Slider from "react-slick"
import productService from '../services/productService'
import ProductCard from './common/ProductCard'
import QuickViewModal from './common/QuickViewModal'
import '../assets/css/custom.css'

const FeaturedProductsSlider = () => {
    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [quickViewProduct, setQuickViewProduct] = useState(null)
    const [showQuickView, setShowQuickView] = useState(false)

    useEffect(() => {
        const fetchFeaturedProducts = async () => {
            try {
                setLoading(true)
                const response = await productService.getFeaturedProducts(12)
                if (response && response.succeeded) {
                    setProducts(response.products || [])
                }
            } catch (err) {
                console.error('Öne çıkan ürünler yüklenemedi:', err)
            } finally {
                setLoading(false)
            }
        }

        fetchFeaturedProducts()
    }, [])


    const handleQuickView = (product) => {
        setQuickViewProduct(product)
        setShowQuickView(true)
    }

    const closeQuickView = () => {
        setShowQuickView(false)
        setQuickViewProduct(null)
    }

    function SampleNextArrow(props) {
        const { className, onClick } = props
        return (
            <button
                type="button" 
                onClick={onClick}
                className={`${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1 shadow-sm`}
                style={{
                    width: '40px',
                    height: '40px',
                    border: '2px solid var(--main-600)',
                    zIndex: 10
                }}
            >
                <i className="ph ph-caret-right" />
            </button>
        )
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1 shadow-sm`}
                style={{
                    width: '40px',
                    height: '40px',
                    border: '2px solid var(--main-600)',
                    zIndex: 10
                }}
            >
                <i className="ph ph-caret-left" />
            </button>
        )
    }

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        autoplay: true,
        autoplaySpeed: 4000,
        className: 'overflow-visible',
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    }

    if (loading) {
        return (
            <section className="featured-products py-80">
                <div className="container container-lg">
                    <div className="text-center mb-48">
                        <h2 className="mb-12">Öne Çıkan Ürünler</h2>
                        <p className="text-neutral-600">En popüler ve favori ürünlerimiz</p>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Yükleniyor...</span>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    if (!products || products.length === 0) {
        return null
    }

    return (
        <section className="featured-products py-60 bg-gradient-to-br from-neutral-50 to-main-50">
            <div className="container container-lg">
                <div className="section-heading text-center mb-40">
                    <h2 className="mb-12" style={{ fontSize: 'clamp(24px, 5vw, 32px)' }}>Öne Çıkan Ürünler</h2>
                    <p className="text-neutral-600 mb-0" style={{ fontSize: 'clamp(14px, 3vw, 16px)' }}>En popüler ve favori ürünlerimiz</p>
                </div>

                <div className="featured-slider-container position-relative">
                    <Slider {...settings}>
                        {products.map((product) => (
                            <div key={product.id} className="px-4">
                                <ProductCard 
                                    product={product} 
                                    viewMode="slider"
                                    showQuickView={true}
                                    onQuickView={handleQuickView}
                                    compact={false}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

                <div className="text-center mt-40">
                    <Link 
                        to="/shop" 
                        className="btn btn-main rounded-pill py-16 px-32 text-white fw-semibold transition-2 hover-bg-main-800 shadow-lg"
                        style={{ 
                            backgroundColor: '#299E60',
                            border: 'none',
                            fontSize: 'clamp(14px, 3vw, 16px)'
                        }}
                    >
                        Tüm Ürünleri Gör
                        <i className="ph ph-arrow-right ms-8"></i>
                    </Link>
                </div>
            </div>

            {/* Quick View Modal */}
            <QuickViewModal
                product={quickViewProduct}
                isOpen={showQuickView}
                onClose={closeQuickView}
            />
        </section>
    )
}

export default FeaturedProductsSlider

